import React from "react";
import { CategoryContainer } from "../../components/CategoryContainer";
import { AutocompleteRHF } from "../../components/RHFWrappedComponents";
import { collegeReadinessProgramList } from "../../data";
import { Typography } from "@mui/material";

export function CollegeReadiness() {
  return (
    <CategoryContainer title="College Readiness Program">
      <Typography variant="body2">
        Information about any programs that are helping you prepare and apply to
        college.
      </Typography>
      <AutocompleteRHF
        name={"collegeInfo.collegeReadinessPrograms"}
        options={collegeReadinessProgramList}
        selectLabel={"Program Name"}
        multiple={true}
      />
    </CategoryContainer>
  );
}
